<template>
    <FormCreator
        v-if="!initLoading"
        :errors="errors"
        :popup="popup"
        :sections="formSections"
        ref="infoInputs"
        section="infoInputs"
        @enter="$emit('enter')"
    />
</template>
<script>
export default {
    components: {
        FormCreator: () => import('@/components/forms/EditSection.vue')
    },
    props: {
        popup: {
            type: Boolean,
            default: false
        },
        form: {
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },
        role: {
            type: String,
            default: 'parent'
        },
        selectedLanguage: {
            type: String,
            default: 'en'
        }
    },
    data() {
        return {
            errors: new this.$Errors(),
            formSections: {},
            initLoading: true
        }
    },
    methods: {
        getFormData() {
            let data = {}
            if (!this.$Utils.setForm(this.formSections, data, this.errors)) {
                this.$Notif.error('FIELDS_STILL_INVALID')
                return
            }
            return this.form.vars.map(field => {
                const value = this.formSections[field.key].value
                field.input =
                    this.getFieldType(field) == 'multiselect'
                        ? value.join(', ')
                        : value
                return field
            })
        },
        dateSelected(date, field) {
            field.input = date
            this.$forceUpdate()
        },
        setFormFields() {
            this.formSections = {}
            this.form.vars.forEach(field => {
                const type = this.getFieldType(field)
                const sectionType = this.getSectionType(type)
                this.formSections[field.key] = {
                    title:
                        field.labels[this.selectedLanguage] ||
                        field.description,
                    value: this.getSectionValue(type),
                    type: sectionType,
                    required: field.required,
                    hidden: field.role != this.role,
                    key: field.key,
                    linkified: sectionType == 'text-input'
                }
                if (
                    [
                        'select',
                        'multiselect',
                        'gender',
                        'parent_1_language',
                        'parent_2_language',
                        'pickuper_1_document_type',
                        'pickuper_2_document_type',
                        'pickuper_3_document_type'
                    ].includes(type)
                ) {
                    this.formSections[field.key].options =
                        this.getSectionOptions(field)
                }
                this.getCustomAtributes(this.formSections[field.key], type)
            })
            this.initLoading = false
        },
        getCustomAtributes(section, type) {
            switch (type) {
                case 'parent_mail':
                    section.email = true
                    break
            }
        },
        getSectionValue(type) {
            switch (type) {
                case 'multiselect':
                    return []
                case 'date':
                case 'contract_end_date':
                case 'contract_start_date':
                    return this.$moment().format('YYYY-MM-DD')
                default:
                    return ''
            }
        },
        getSectionOptions(field) {
            return field.selections.map(selection => {
                return {
                    value: selection,
                    display: selection
                }
            })
        },
        getFieldType({ type, custom_field_type }) {
            return type == 'custom_field' ? custom_field_type : type
        },
        getSectionType(type) {
            switch (type) {
                case 'date':
                case 'contract_start_date':
                case 'contract_end_date':
                case 'birthday':
                    return 'date-select'
                case 'select':
                case 'gender':
                case 'parent_1_language':
                case 'parent_2_language':
                case 'pickuper_1_document_type':
                case 'pickuper_2_document_type':
                case 'pickuper_3_document_type':
                    return 'single-select'
                case 'multiselect':
                    return 'multi-select'
                case 'pesel':
                case 'parent_1_pesel':
                case 'parent_2_pesel':
                case 'pickuper_1_pesel':
                case 'pickuper_2_pesel':
                case 'pickuper_3_pesel':
                case 'number':
                    return 'number-input'
                default:
                    return 'text-input'
            }
        }
    },
    watch: {
        selectedLanguage() {
            this.setFormFields()
        }
    },
    mounted() {
        this.setFormFields()
    }
}
</script>
<style lang="scss" scoped>
.apply-form-field {
    margin-top: 1rem;
}
.form-field-label {
    font-family: $input-family;
    color: $input;
    font-size: 1rem;
    margin-bottom: 0.25rem;
}
</style>
